import { API_AUTH } from "./common";

const ThemMoiKhachHangApi = {
  themMoiKhachHang: (customer) =>
    API_AUTH.post(
      `quanlykhachhang/cap-nhat-thong-tin`,
      customer
    ),
};

export default ThemMoiKhachHangApi;
